import React, { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAsset } from '../../../asset/asset-context';
import { DepositWithdrawMode } from '../../ibc-transfer-types';
import { useIbcTransfer } from '../../ibc-transfer-context';
import IbcTransfer from '../../ibc-transfer';
import { BridgeTransfer } from '../history/bridge-hisotry-types';
import { useBridgeDepositWithdraw } from './bridge-deposit-withdraw-context';
import './bridge-deposit-withdraw.scss';

interface BridgeDepositWithdrawProps {
    mode: DepositWithdrawMode;
}

const BridgeDepositWithdraw: React.FC<BridgeDepositWithdrawProps> = ({ mode }) => {
    const navigate = useNavigate();
    const {
        depositWithdrawMode,
        setEnabled,
        setDepositWithdrawMode,
        setSourceId,
        setDestinationId,
        setOnExploreClick,
    } = useBridgeDepositWithdraw();
    const { sourceData, destinationData } = useIbcTransfer();
    const { vsAsset } = useAsset();

    useEffect(() => {
        setOnExploreClick(() => ((transfer: BridgeTransfer) => {
            navigate(`/bridge/cctp/${transfer.hash || '-'}/${transfer.ibcHash || '-'}`);
        }));
    }, [ navigate, setOnExploreClick ]);

    useEffect(() => {
        setEnabled(true);
        return () => setEnabled(false);
    }, [ setEnabled ]);

    useEffect(() => setDepositWithdrawMode(mode), [ mode, setDepositWithdrawMode ]);

    const availableBalances = useMemo(() => vsAsset ? [ vsAsset ] : [], [ vsAsset ]);

    return (
        <div className='page bridge-deposit-withdraw-page'>
            <IbcTransfer
                availableBalances={availableBalances}
                depositWithdrawMode={depositWithdrawMode}
                onDepositWithdrawModeChange={(mode) => {
                    if (sourceData.network) {
                        setDestinationId(sourceData.network?.chainId);
                    }
                    if (destinationData.network) {
                        setSourceId(destinationData.network?.chainId);
                    }
                    setDepositWithdrawMode(mode);
                    navigate(`/bridge/cctp/${mode.toLowerCase()}`, { relative: 'path', replace: true });
                }}
            />
        </div>
    );
};

export default BridgeDepositWithdraw;

